import { render, staticRenderFns } from "./Analises.vue?vue&type=template&id=ddc9d144&"
import script from "./Analises.vue?vue&type=script&lang=js&"
export * from "./Analises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports